import { sortByProp } from '@Sage/ssm-utils';

import {
    CLEAR_ALL,
    CLEAR_CURRENT_USER,
    GET_IMPL_SUMMARY_REQUEST,
    GET_IMPL_SUMMARY_SUCCESS,
    GET_IMPL_SUMMARY_ERROR,
    GET_SSO_PROVIER_SUCCESS,
    GET_SSO_PROVIER_ERROR,
    GET_USERS_HIERACHY_REQUEST,
    GET_USERS_HIERACHY_SUCCESS,
    GET_USERS_HIERACHY_ERROR,
    GET_USER_REQUEST,
    GET_USER_SUCCESS,
    GET_USER_ERROR,
    GET_USER_SCHEMA_SUCCESS,
    GET_USER_SCHEMA_ERROR,
    GET_USER_COUNTRY_CODES_SUCCESS,
    GET_USER_COUNTRY_CODES_ERROR,
} from 'constants/ActionTypes';

const initialState = {
    summary: null,
    summaryLoading: false,
    hierachy: null,
    hierachyLoading: false,
    hierachyError: false,
    currentUser: null,
    currentUserLoading: false,
    currentUserError: false,
    schema: {},
};

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_IMPL_SUMMARY_REQUEST:
            return {
                ...state,
                summaryLoading: true,
            };

        case GET_IMPL_SUMMARY_SUCCESS:
            return {
                ...state,
                summary: action.payload,
                summaryLoading: false,
            };

        case GET_IMPL_SUMMARY_ERROR:
            return {
                ...state,
                summary: null,
                summaryLoading: false,
            };

        case GET_USERS_HIERACHY_REQUEST:
            return {
                ...state,
                hierachyLoading: true,
                hierachyError: false,
            };

        case GET_USERS_HIERACHY_SUCCESS:
            return {
                ...state,
                hierachyLoading: false,
                hierachyError: false,
                hierachy: action.payload,
            };

        case GET_USERS_HIERACHY_ERROR:
            return {
                ...state,
                hierachyLoading: false,
                hierachyError: true,
                hierachy: null,
            };

        case GET_USER_REQUEST:
            return {
                ...state,
                currentUserLoading: true,
                currentUserError: false,
            };

        case GET_USER_SUCCESS:
            return {
                ...state,
                currentUserLoading: false,
                currentUser: action.payload,
                currentUserError: false,
            };

        case GET_USER_ERROR:
            return {
                ...state,
                currentUserLoading: false,
                currentUser: null,
                currentUserError: true,
            };

        case GET_SSO_PROVIER_SUCCESS:
            return {
                ...state,
                authConfiguration: action.payload,
            };

        case GET_SSO_PROVIER_ERROR:
            return {
                ...state,
                authConfiguration: null,
            };

        case GET_USER_SCHEMA_SUCCESS:
            return {
                ...state,
                schema: action.payload,
            };

        case GET_USER_SCHEMA_ERROR:
            return {
                ...state,
                schema: {},
            };

        case GET_USER_COUNTRY_CODES_SUCCESS:
            return {
                ...state,
                countryCodes: action.payload,
                countryCodesNames: sortByProp(
                    action.payload.map((el) => ({
                        label: el.country,
                        value: el.id,
                    })),
                    'label',
                ),
                countryCodesPrefixes: action.payload.map((el) => ({
                    label: el.prefix,
                    value: el.id,
                })),
            };

        case GET_USER_COUNTRY_CODES_ERROR:
            return {
                ...state,
                countryCodes: [],
                countryCodesNames: [],
                countryCodesPrefixes: [],
            };

        case CLEAR_CURRENT_USER:
            return {
                ...state,
                currentUser: null,
            };

        case CLEAR_ALL:
            return initialState;

        default:
            return {
                ...state,
            };
    }
}
